import type { VenueDetail, VenueDraft } from "./venues.ts";

export interface VenueRecovery {
  version: 1;
  ownerId: string;
  selected: string | null;
  venueId: string;
  detail: VenueDetail | null;
  draft: VenueDraft;
  request: { key: string; id: string } | null;
}
const key = (owner: string) => `field-observation.venue-draft.${owner}`;
// A tab-scoped recovery copy survives sign-in renewal and reload. Never restore
// another account's draft, even when the browser is shared. The original token
// and receipt id travel with the draft, so recovery cannot overwrite a newer
// server version or duplicate a save whose response was lost.
export function readVenueRecovery(owner?: string, storage?: Pick<Storage, "getItem">): VenueRecovery | null {
  if (!owner) return null;
  try {
    const value = JSON.parse((storage ?? sessionStorage).getItem(key(owner)) ?? "null");
    if (value?.version !== 1 || value.ownerId !== owner || typeof value.venueId !== "string" ||
      !(value.selected === null || typeof value.selected === "string") || !value.draft?.values ||
      !Array.isArray(value.draft.bins) || !Array.isArray(value.draft.schedule)) return null;
    return value;
  } catch { return null; }
}
export function writeVenueRecovery(value: VenueRecovery, storage?: Pick<Storage, "setItem">): boolean {
  try { (storage ?? sessionStorage).setItem(key(value.ownerId), JSON.stringify(value)); return true; }
  catch { return false; }
}
export function clearVenueRecovery(owner?: string, storage?: Pick<Storage, "removeItem">): void {
  if (owner) try { (storage ?? sessionStorage).removeItem(key(owner)); } catch { /* the visible draft still remains */ }
}
